export enum RecalculateOperationType {
  UNDO_RECALCULATE,
  RECALCULATE,
}
